/**=========================================================
 * Module: utils.js
 * Utility library to use across the theme
 =========================================================*/

App.service('Utils', ["$window", "APP_MEDIAQUERY", ($window, APP_MEDIAQUERY) => {
    const $html = angular.element("html"), $win  = angular.element($window), $body = angular.element('body')

    return {
      // DETECTION
      support: {
        transition: ((() => {
                const transitionEnd = ((() => {
                    const element = document.body || document.documentElement

                    const transEndEventNames = {
                        WebkitTransition: 'webkitTransitionEnd',
                        MozTransition: 'transitionend',
                        OTransition: 'oTransitionEnd otransitionend',
                        transition: 'transitionend'
                    }

                    let name

                    for (name in transEndEventNames) {
                        if (element.style[name] !== undefined) return transEndEventNames[name]
                    }
                })())

                return transitionEnd && { end: transitionEnd }
            }))(),
        animation: ((() => {

            const animationEnd = ((() => {
                const element = document.body || document.documentElement

                const animEndEventNames = {
                    WebkitAnimation: 'webkitAnimationEnd',
                    MozAnimation: 'animationend',
                    OAnimation: 'oAnimationEnd oanimationend',
                    animation: 'animationend'
                }

                let name

                for (name in animEndEventNames) {
                    if (element.style[name] !== undefined) return animEndEventNames[name]
                }
            })())

            return animationEnd && { end: animationEnd }
        }))(),
        requestAnimationFrame: window.requestAnimationFrame ||
                               window.webkitRequestAnimationFrame ||
                               window.mozRequestAnimationFrame ||
                               window.msRequestAnimationFrame ||
                               window.oRequestAnimationFrame ||
                               (callback => { window.setTimeout(callback, 1000/60); }),
        touch: (
            ('ontouchstart' in window && navigator.userAgent.toLowerCase().match(/mobile|tablet/)) ||
            (window.DocumentTouch && document instanceof window.DocumentTouch)  ||
            (window.navigator['msPointerEnabled'] && window.navigator['msMaxTouchPoints'] > 0) || //IE 10
            (window.navigator['pointerEnabled'] && window.navigator['maxTouchPoints'] > 0) || //IE >=11
            false
        ),
        mutationobserver: (window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver || null)
      },
      // UTILITIES
      isInView(element, options) {

          const $element = $(element)

          if (!$element.is(':visible')) {
              return false
          }

          const window_left = $win.scrollLeft(), window_top  = $win.scrollTop(), offset      = $element.offset(), left        = offset.left, top         = offset.top

          options = $.extend({topoffset:0, leftoffset:0}, options)

          if (top + $element.height() >= window_top && top - options.topoffset <= window_top + $win.height() &&
              left + $element.width() >= window_left && left - options.leftoffset <= window_left + $win.width()) {
            return true
          } else {
            return false
          }
      },
      langdirection: $html.attr("dir") == "rtl" ? "right" : "left",
      isTouch() {
        return $html.hasClass('touch')
      },
      isSidebarCollapsed() {
        return $body.hasClass('aside-collapsed')
      },
      isSidebarToggled() {
        return $body.hasClass('aside-toggled')
      },
      isMobile() {
        return $win.width() < APP_MEDIAQUERY.tablet
      },
      isNum(str){
        return /^\d+$/.test(str)
      }
    }
}])
